import Model from '@/models/Model'

export default class SlSaleInvoice extends Model {
    static includes = [
        'sl_service_order_as_affected',
        'sl_service_order_as_new',
        'sl_customer_account_movement',
        'sl_customer',
        'sl_customer_branch_offices',
        'sl_detail_sale_invoices.wh_product',
        'g_company',
        'g_state',
    ]
    static appends = ['account_receivable']

    SII_DOCUMENTS = [
        {
            code: 33,
            name: 'Factura Electrónica',
        },
        {
            code: 39,
            name: 'Boleta Electrónica',
        },
        {
            code: 61,
            name: 'Nota de crédito',
        },
    ]

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get g_state_name() {
        return this.getProperty('g_state.state', '-')
    }

    mapDetail = item => ({
        ...item,
        wh_product_internal_code: item.wh_product.internal_code,
        wh_product_name: item.wh_product.name,
    })

    reset() {

        //
        this.sl_detail_sale_invoices = this.sl_detail_sale_invoices.map(this.mapDetail)

        //
        return this
    }

    resource() {
        return 'sl_sale_invoice'
    }

    get account_receivable_pay_date() {
        return this.getProperty('account_receivable.pay_date', '')
    }

    get account_receivable_real_pay_date() {
        return this.getProperty('account_receivable.real_pay_date', '')
    }
    
    get number_of_doc() {
        return this.getProperty('number','')
    }

    get documentType() {
        try {
            let { dte_type_invoice } = this
            let foundDocument = this.SII_DOCUMENTS.filter(item => {
                if (dte_type_invoice === item.code) {
                    return item
                }
            })
            return foundDocument ? foundDocument[0].name : ''
        } catch (e) {
            return `e: ${e}`
        }
    }

    get payDate() {
        try {
            if (this.account_receivable !== null) {
                let { pay_date } = this.account_receivable
                if (pay_date !== null) {
                    return pay_date
                } else {
                    return ''
                }
            } else return ''
        } catch (e) {
            return `e: ${e}`
        }
    }

    get realPayDate() {
        try {
            if (this.account_receivable !== null) {
                let { real_pay_date } = this.account_receivable
                if (real_pay_date !== null) return real_pay_date
                else return ''
            } else return ''
        } catch (e) {
            return `e: ${e}`
        }
    }

    get amountSaleInvoice() {
        try {
            let { amount } = this.account_receivable
            if (amount !== null || amount !== '') return amount
        } catch (e) {
            return `e: ${e}`
        }
    }

    get paidAmount() {
        try {
            let { paid_amount } = this.account_receivable
            if (paid_amount !== null || paid_amount !== '') return paid_amount
        } catch (e) {
            return `e: ${e}`
        }
    }

    get balanceSaleInvoice() {
        try {
            let { balance } = this.account_receivable
            if (balance !== null || balance !== '') return balance
        } catch (e) {
            return `e: ${e}`
        }
    }

    get file_name() {
        return `FACTURA_VENTA_${this.number}`
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_branch_offices_address() {
        return this.getProperty('sl_customer_branch_offices.address', '-')
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get sl_customer_business_name() {
        return this.getProperty('sl_customer.business_name', '-')
    }

    /**
     * Returns a pdf representation of the object.
     *
     * @return     {<type>}  Pdf representation of the object.
     */
    toPdf() {
        return this.pdf().then(this.showFile(this.file_name, 'pdf'))
    }
}
